import { roomSubjectApi, roomApi, setRequestHeaders, useRoomBaseServer } from 'middle-domain';
import { setRequestHeaders as setLoginHeaders } from '@vhcl/saas-login';
import tidCenter from '@/app-shared/utils/tidCenter.js';
import { GeneralKeyValueStorage } from '@/app-shared/utils/storage.js';
import { getQueryString, addParamsToUrl, removeUrlParameter } from '@/app-shared/utils/tool.js';
/**
 * 灰度初始化
 * @param {*} options
 * @returns
 */
export default function grayInit(options) {
  return new Promise(resolve => {
    if (options.meta.grayType == 'webinar') {
      const ticket = getQueryString('ticket');
      const roomTokenStorage = new GeneralKeyValueStorage('roomToken', 10);
      const webinarId = options.params.id || options.query.webinar_id;
      useRoomBaseServer()
        .webinarInitBefore({
          webinar_id: webinarId,
          source: options.source,
          scene_id: 1,
          ticket: ticket || undefined,
          room_token: roomTokenStorage.getValueByKey(webinarId) || undefined
        })
        .then(res => {
          if (res.code == 200) {
            const url = removeUrlParameter(window.location.href, 'ticket');

            if (res.data?.ticket?.check_ticket_url) {
              window.location.href = `${addParamsToUrl(res.data?.ticket?.check_ticket_url, {
                callback_url: url
              })}`;
              roomTokenStorage.deleteKeyValue(webinarId);
              return;
            } else if (res.data?.ticket?.room_token) {
              roomTokenStorage.setValueByKey(webinarId, res.data?.ticket?.room_token);
            }
            const grayUserId = (res.code == 200 && res.data && res.data.user_id) || null;
            setGrayUserId(grayUserId);
            sessionStorage.setItem('paas_app_id', res.data.paas_app_id);
            // v7.9.3 新增返回值专题id:subject_id , 如果不是专题该值=0
            const subjectId = res.code == 200 && res.data && res.data.subject_id;
            subjectId && subjectId != '0'
              ? window.sessionStorage.setItem('subjectId', subjectId)
              : window.sessionStorage.removeItem('subjectId');

            // v7.9.3 新增返回值:is_private_consumer, 是否有B下C权限：1.是，0.否
            const isPrivateConsumer =
              (res.code == 200 && res.data && res.data.is_private_consumer) || 0;
            window.sessionStorage.setItem('isPrivateConsumer', isPrivateConsumer);
          }
          resolve(res);
        })
        .catch(res => {
          console.log('webinarInitBefore------->', res);
          resolve({
            code: res?.status || res?.response?.status
          });
        });
    } else if (options.meta.grayType == 'subject') {
      roomSubjectApi.subject
        .subjectInitBefore({
          subject_id:
            options.path.indexOf('/special/entryform/') != -1 ? options.params.id : options.query.id
        })
        .then(res => {
          if (res.code == 200) {
            const grayUserId = (res.code == 200 && res.data && res.data.user_id) || null;
            setGrayUserId(grayUserId);

            // v7.9.3 新增返回值专题id:subject_id , 如果不是专题该值=0
            const subjectId = (res.code == 200 && res.data && res.data.subject_id) || 0;
            window.sessionStorage.setItem('subjectId', subjectId);

            // v7.9.3 新增返回值:is_private_consumer, 是否有B下C权限：1.是，0.否
            const isPrivateConsumer =
              (res.code == 200 && res.data && res.data.is_private_consumer) || 0;
            window.sessionStorage.setItem('isPrivateConsumer', isPrivateConsumer);
            window.sessionStorage.setItem(
              'subject_permission_value',
              res.data.permission.permission_value
            );
          }
          resolve(res);
        })
        .catch(res => {
          console.log('subjectInitBefore------->', res);
          resolve({
            code: res?.status || res?.response?.status
          });
        });
    } else if (options.meta.grayType == 'user') {
      const grayUserId = options.params.id || null;
      setGrayUserId(grayUserId);
      // 忘记密码不需要token, 不管有没有设置为空字符串
      setRequestHeaders({ token: '' });
      resolve();
    } else {
      setGrayUserId(getQueryString('grayId') || null);
      resolve();
    }
  });
}

/**
 * 设置灰度id
 */
function setGrayUserId(grayUserId) {
  // 存储到 session
  window.sessionStorage.setItem('initGrayId', grayUserId);
  // 设置 domain requestHeader
  setRequestHeaders({
    'gray-id': grayUserId
  });
  setLoginHeaders({ 'gray-id': grayUserId });
  //添加性能监控判断
  if (window.saas_aegis) {
    if (Object.prototype.toString.call(grayUserId) != '[object Null]') {
      window.saas_aegis.setConfig({
        uin: `${grayUserId}`
      });
    }
  }
}

export async function setTidInHeaders(options) {
  let webinarId = null;
  if (options.meta.grayType == 'webinar') {
    webinarId = options.params.id;
  }
  if (sessionStorage.getItem('token')) {
    setRequestHeaders({
      token: sessionStorage.getItem('token')
    });
  }
  const subjectId = window.sessionStorage.getItem('subjectId');
  if (webinarId || subjectId) {
    const tid = await tidCenter.getTid(webinarId, subjectId);
    setRequestHeaders({
      'token-Id': tid || ''
    });
  }
}
